angular.module('mtic.components.notifications')
.directive('studentQuestionnairePrompt', function ($log, EventManager, $timeout, language, api, notificationService) {
  return {
    templateUrl: 'template.html',
    scope: {
        isBaseline: '=?',
        setResource: '=?',        
        isPostTest: '=?',
    },
    link: function (scope) {
      var eventManager = new EventManager('studentQuestionnairePrompt');
      scope.languageService = language;
      scope.isGerman = function(){
        return language.getCurrentSelectedLanguage() === 'de';
      }
      
    }
  }
})
